export const inputDark = {
  outline: 'none',
  border: 'none',
  padding: 'xxs',
  color: 'white',
  borderRadius: 'xl',
  height: 44,
  backgroundColor: 'grey/dark/background',
  labelColor: 'white',
  fontSize: '16px',
  fontFamily: 'regular',
  letterSpacing: '0.5px',
  states: {
    '&::placeholder': {
      color: 'grey/light',
    },
    '&:disabled': {
      opacity: 0.5,
    },
  },
  inputTextStyleError: {
    bg: 'error/opacity',
    border: 'solid 1px',
    borderColor: 'error/bright',
    color: 'white',
  },
};
